import * as React from 'react';
import { PageEnterDetails } from './page-enter-details/page-enter-details';
import { PageConfirmMobileNumber } from './page-confirm-mobile-number/page-confirm-mobile-number';
import { PagePaymentMethod } from './page-payment-method/page-payment-method';
import { PageConfirmBankAccount } from './page-confirm-bank-account/page-confirm-bank-account';
import { PageSuccess } from './page-success/page-success';

export enum PayerOnboardingPage {
	EnterDetails,
	ConfirmMobileNumber,
	PaymentMethod,
	ConfirmBankAccount,
	Success,
}

// we can't define a proper signature for this in the current version of typescript.
// const pageLookups : { [ pageType : PayerOnboardingPage ] : React.Commponent }
// Perhaps when we upgrade
const pageLookups : any = {
	[PayerOnboardingPage.EnterDetails]: PageEnterDetails,
	[PayerOnboardingPage.ConfirmMobileNumber]: PageConfirmMobileNumber,
	[PayerOnboardingPage.PaymentMethod]: PagePaymentMethod,
	[PayerOnboardingPage.ConfirmBankAccount]: PageConfirmBankAccount,
	[PayerOnboardingPage.Success]: PageSuccess,
};

export function PayerOnboardingViewForPageType(pageType: PayerOnboardingPage) : React.Component {
	return pageLookups[pageType];
}
